import * as React from 'react';
import { useQuery } from "react-query";

import { fetchAdministrationUtilisateur } from 'utils/queries';

import AdministrationUtilisateur from './AdministrationUtilisateur'

const AdministrationUtilisateurContainer = ({ id }) => {

    const [utilisateur, setUtilisateur] = React.useState(null);

    const [loading, setLoading] = React.useState(false);

    /** On récupère un utilisateur */
    const query = useQuery(`AdministrationUtilisateur_${id}`, () => fetchAdministrationUtilisateur(id));

    React.useEffect(() => {

        if (!query.isLoading && !query.error && query.data) {
            setLoading(query.isLoading);
            setUtilisateur(query.data);
        }

    }, [utilisateur, query]);

    return (
        <>
            {
                utilisateur &&
                <AdministrationUtilisateur
                    utilisateur={utilisateur}
                    loading={loading}
                />
            }
        </>
    )

}

export default AdministrationUtilisateurContainer;